export default "__VITE_ASSET__Cqvl5I_v__"